module.exports = __webpack_public_path__ + "static/media/018-bookmark.19cfcab9.svg";